import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../../Common/FormElements/TextInput/TextInput";

export const infoElements = [
  {
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    placeholder: "Enter depot name",
  },
  {
    name: "code",
    label: "Code",
    type: "text",
    required: true,
    placeholder: "Enter depot code",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Enter depot email",
  },
  {
    name: "phone",
    label: "Phone",
    type: "tel",
    required: false,
    placeholder: "Enter depot phone number",
  },
];

const DepotInformations = ({ forms, setForms }) => {
  const { t } = useTranslation("common");
  const [errors, setErrors] = useState({});

  const handleInputChange = (name, value) => {
    setForms((prev) => ({
      ...prev,
      infos: {
        ...prev.infos,
        [name]: value,
      },
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateField = (element, value) => {
    if (element.required && (!value || value.trim() === "")) {
      return `${t(element.label)} ${t("is required")}`;
    }

    if (element.type === "email" && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return `${t(element.label)} ${t("must be a valid email")}`;
      }
    }

    return null;
  };

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="modalContent px-5 pt-4 pb-5">
        <div className="row">
          {infoElements.map((element, index) => (
            <div key={element.name} className="col-md-6 mb-3">
              <label className="form-label">
                {t(element.label)}
                {element.required && <span className="text-danger">*</span>}
              </label>
              <TextInput
                name={element.name}
                type={element.type}
                value={forms?.infos[element.name] || ""}
                placeholder={t(element.placeholder)}
                callback={(e) =>
                  handleInputChange(element.name, e.target.value)
                }
                onBlur={(e) => {
                  const error = validateField(element, e.target.value);
                  if (error) {
                    setErrors((prev) => ({
                      ...prev,
                      [element.name]: error,
                    }));
                  }
                }}
                className={errors[element.name] ? "border-danger" : ""}
              />
              {errors[element.name] && (
                <div className="text-danger small mt-1">
                  {errors[element.name]}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DepotInformations;
